import { useAsyncCallback } from 'react-async-hook';
import { useAuthStore } from '../store/use-auth-store';
import { useInviteStore } from '../store/use-invite-store';
import { api } from './instance';
import { getInvite } from './use-get-invite';
import { decorateError } from './utils';

// TODO: the verify OTP endpoint should not return a JWT but should instead set
// a HTTP only cookie for authentication.
export function useValidateOtp() {
  const { invite } = useInviteStore();
  const { setJwt } = useAuthStore();
  const { setInvite } = useInviteStore();

  return useAsyncCallback(async (code) => {
    try {
      const jwt = await api.public
        .post('onlinebooking/verify-otp', {
          json: {
            onlineBookingReference: invite.reference,
            otp: code,
          },
        })
        .json();
      setJwt(jwt);
      return await getInvite(invite.reference, setInvite);
    } catch (error) {
      switch (error.response?.status) {
        case 400: {
          throw decorateError(error, 'errors.invalidOtp.title', 'errors.invalidOtp.details');
        }
      }
      throw decorateError(error, 'errors.serverErrorOtp.title', 'errors.serverErrorOtp.details');
    }
  });
}
